export default "__VITE_ASSET__Dk77FBx6__"